import { render, staticRenderFns } from "./networkDetector.vue?vue&type=template&id=47335ded&scoped=true"
import script from "./networkDetector.vue?vue&type=script&lang=js"
export * from "./networkDetector.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=47335ded&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47335ded",
  null
  
)

export default component.exports